// import React, { useState, useRef, useEffect } from "react";
// import data from "../resources/data.pdf";
// import "react-pdf/dist/esm/Page/TextLayer.css";
// import "react-pdf/dist/esm/Page/AnnotationLayer.css";
// import { useSelector } from "react-redux";
// import { PDFObject } from "react-pdfobject";

// export default function PdfConnector({ path }) {
//   console.log("LOADING PDF");
//   const pageNumber = useSelector((state) => state.page.value);
//   return (
//     <div style={{ padding: "1%", maxWidth: "50%" }}>
//       <div
//         style={{
//           width: "100%",
//           height: "90vh",
//           background: "#F2F4F7",
//           borderRadius: "10px",
//           boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
//           marginBottom: "10px", // Added margin-bottom
//         }}
//       >
//         <h1
//           style={{
//             fontSize: "26px",
//             paddingTop: "2%",
//             marginBottom: "10px",
//             paddingLeft: "4%",
//           }}
//         >
//           Raw PDF
//         </h1>

//         <PDFObject
//           url={data}
//           key={pageNumber}
//           height="90vh"
//           width="40vw"
//           page={pageNumber}
//         />
//       </div>
//     </div>
//   );
// }

import React from "react";
//import data from "../resources/data.pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { useSelector } from "react-redux";
import { PDFObject } from "react-pdfobject";

export default function PdfConnector({ data }) {
  console.log("LOADING PDF");
  const pageNumber = useSelector((state) => state.page.value);
  return (
    <div style={{ padding: "2%", paddingRight: "2%", paddingTop: "1.5%"}}>
      <div
        style={{
          width: "100%",
          height: "90vh",
          background: "#F2F4F7",
          borderRadius: "10px",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          marginBottom: "10px", // Added margin-bottom
        }}
      >
        <h1
          style={{
            fontSize: "26px",
            paddingTop: "2%",
            marginBottom: "10px",
            paddingLeft: "4%",
          }}
        >
          Raw PDF
        </h1>

        <PDFObject
          url={data}
          key={pageNumber}
          height="90vh"
          width="100%"
          page={pageNumber}
        />
      </div>
    </div>
  );
}


